<template>
  <div class="aw-page">
    <HeadNav selectedLanguage="en" page="mods" />
    <main>
      <section class="content-section">
        <h1>WhatsApp Mods – Best WA Apps &amp; Alternatives</h1>
        <p>Choose a WA app based on the features you need, such as <strong>privacy controls, custom themes, chat locking, hidden online status, larger file sharing, auto-reply, and message scheduling</strong>. Different WhatsApp mods offer different combinations of these features.</p>
      </section>

      <AlternativesGrid title="Popular WhatsApp Mods" :items="alts" />

      <section class="content-section">
        <h2>WhatsApp Mods Comparison</h2>
        <SimpleTable caption="WhatsApp mods comparison" :columns="compareCols" :rows="compareRows" />
      </section>

      <section class="content-section">
        <h2>Which WhatsApp Mod Should You Choose?</h2>
        <p>Choose a WhatsApp mod based on the features you need. <strong>GB WhatsApp</strong> is a good starting point for users looking for a combination of privacy, customization, and additional messaging features.</p>
        <p><strong>Note:</strong> WhatsApp mods are unofficial third-party applications. Features and availability can vary by version, and using modified apps may involve security, privacy, compatibility, or account restriction risks.</p>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/site.scss';
import HeadNav from '@/components/HeadNav.vue';
import AlternativesGrid from '@/components/AlternativesGrid.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import { MODS } from '@/content/mods';

export default {
  name: 'Mods',
  components: { HeadNav, AlternativesGrid, SimpleTable },
  data() {
    return {
      alts: [MODS.gb, MODS.fm, MODS.yo, MODS.blue, MODS.og, MODS.aero].map((mod) => ({
        ...mod,
        text: mod.description,
      })),
      compareCols: ['WA App', 'Privacy', 'Themes', 'Customization', 'Media Sharing'],
      compareRows: [
        ['GB WhatsApp', 'Yes', 'Yes', 'Yes', 'Yes'],
        ['FM WhatsApp', 'Yes', 'Yes', 'Yes', 'Yes'],
        ['YOWhatsApp', 'Yes', 'Yes', 'Yes', 'Yes'],
        ['WhatsApp Plus', 'Yes', 'Yes', 'Yes', 'Yes'],
        ['MB WhatsApp', 'Yes', 'Yes', 'Yes', 'Yes'],
        ['OG WhatsApp', 'Yes', 'Yes', 'Yes', 'Yes'],
        ['Aero WhatsApp', 'Yes', 'Yes', 'Yes', 'Yes'],
      ],
    };
  },
};
</script>
